/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field__Enum_Teachingsubjectinterest_Subject_Computer_Science24Inputs */

const en__field__enum_teachingsubjectinterest_subject_computer_science24 = /** @type {(inputs: _Field__Enum_Teachingsubjectinterest_Subject_Computer_Science24Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Computer Science`)
};

const de__field__enum_teachingsubjectinterest_subject_computer_science24 = /** @type {(inputs: _Field__Enum_Teachingsubjectinterest_Subject_Computer_Science24Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Informatik`)
};

/**
* | output |
* | --- |
* | "Computer Science" |
*
* @param {_Field__Enum_Teachingsubjectinterest_Subject_Computer_Science24Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field__enum_teachingsubjectinterest_subject_computer_science24 = /** @type {((inputs?: _Field__Enum_Teachingsubjectinterest_Subject_Computer_Science24Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field__Enum_Teachingsubjectinterest_Subject_Computer_Science24Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field__enum_teachingsubjectinterest_subject_computer_science24(inputs)
	return de__field__enum_teachingsubjectinterest_subject_computer_science24(inputs)
});
export { _field__enum_teachingsubjectinterest_subject_computer_science24 as "_field__enum_teachingSubjectInterest_SUBJECT_COMPUTER_SCIENCE" }